import axios from 'axios'
import {HOST} from '@/utils/http'

export let CONFIG
export const loadEnv = () => axios.get(`${HOST}/front-config`).then(response => {
    CONFIG = response.data
})

